// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_array = require("rescript/lib/js/js_array.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var DateType$ReactHooksTemplate = require("./dateType.res.js");
var ListType$ReactHooksTemplate = require("./listType.res.js");
var TextType$ReactHooksTemplate = require("./textType.res.js");
var EmailType$ReactHooksTemplate = require("./emailType.res.js");
var MsisdnType$ReactHooksTemplate = require("./msisdnType.res.js");
var NumberType$ReactHooksTemplate = require("./numberType.res.js");

function dataTypeName(t) {
  switch (t.TAG) {
    case "ListType" :
        return ListType$ReactHooksTemplate.dataTypeName;
    case "NumberType" :
        return NumberType$ReactHooksTemplate.dataTypeName;
    case "EmailType" :
        return EmailType$ReactHooksTemplate.dataTypeName;
    case "DateType" :
        return DateType$ReactHooksTemplate.dataTypeName;
    case "MsisdnType" :
        return MsisdnType$ReactHooksTemplate.dataTypeName;
    case "TextType" :
        return TextType$ReactHooksTemplate.dataTypeName;
    
  }
}

function dataTypeFromName(dataTypeName) {
  if (dataTypeName === ListType$ReactHooksTemplate.dataTypeName) {
    return {
            TAG: "ListType",
            _0: ListType$ReactHooksTemplate.empty()
          };
  } else if (dataTypeName === NumberType$ReactHooksTemplate.dataTypeName) {
    return {
            TAG: "NumberType",
            _0: NumberType$ReactHooksTemplate.empty()
          };
  } else if (dataTypeName === EmailType$ReactHooksTemplate.dataTypeName) {
    return {
            TAG: "EmailType",
            _0: EmailType$ReactHooksTemplate.empty()
          };
  } else if (dataTypeName === MsisdnType$ReactHooksTemplate.dataTypeName) {
    return {
            TAG: "MsisdnType",
            _0: MsisdnType$ReactHooksTemplate.empty()
          };
  } else if (dataTypeName === DateType$ReactHooksTemplate.dataTypeName) {
    return {
            TAG: "DateType",
            _0: DateType$ReactHooksTemplate.empty()
          };
  } else {
    return {
            TAG: "TextType",
            _0: TextType$ReactHooksTemplate.empty()
          };
  }
}

var dataTypeNames_1 = {
  hd: NumberType$ReactHooksTemplate.dataTypeName,
  tl: {
    hd: EmailType$ReactHooksTemplate.dataTypeName,
    tl: {
      hd: DateType$ReactHooksTemplate.dataTypeName,
      tl: {
        hd: MsisdnType$ReactHooksTemplate.dataTypeName,
        tl: {
          hd: TextType$ReactHooksTemplate.dataTypeName,
          tl: /* [] */0
        }
      }
    }
  }
};

var dataTypeNames = {
  hd: ListType$ReactHooksTemplate.dataTypeName,
  tl: dataTypeNames_1
};

var defaultDataType = {
  TAG: "TextType",
  _0: TextType$ReactHooksTemplate.empty()
};

function valueAsString(t) {
  switch (t.TAG) {
    case "ListType" :
        return Belt_Option.map(ListType$ReactHooksTemplate.value(t._0), (function (list) {
                      return Js_array.joinWith(", ", Belt_List.toArray(list));
                    }));
    case "NumberType" :
        return Belt_Option.map(NumberType$ReactHooksTemplate.value(t._0), (function (prim) {
                      return String(prim);
                    }));
    case "EmailType" :
        return EmailType$ReactHooksTemplate.value(t._0);
    case "DateType" :
        return Belt_Option.map(DateType$ReactHooksTemplate.value(t._0), (function (d) {
                      return d.format("YYYY-MM-DD HH:mm:ss");
                    }));
    case "MsisdnType" :
        return MsisdnType$ReactHooksTemplate.value(t._0);
    case "TextType" :
        return TextType$ReactHooksTemplate.value(t._0);
    
  }
}

function decode(json) {
  var dataTypeName = Json_decode.field("data_type", Json_decode.string, json);
  if (dataTypeName === ListType$ReactHooksTemplate.dataTypeName) {
    return {
            TAG: "ListType",
            _0: Json_decode.field("data_type_property", ListType$ReactHooksTemplate.decode, json)
          };
  } else if (dataTypeName === NumberType$ReactHooksTemplate.dataTypeName) {
    return {
            TAG: "NumberType",
            _0: Json_decode.field("data_type_property", NumberType$ReactHooksTemplate.decode, json)
          };
  } else if (dataTypeName === EmailType$ReactHooksTemplate.dataTypeName) {
    return {
            TAG: "EmailType",
            _0: Json_decode.field("data_type_property", EmailType$ReactHooksTemplate.decode, json)
          };
  } else if (dataTypeName === MsisdnType$ReactHooksTemplate.dataTypeName) {
    return {
            TAG: "MsisdnType",
            _0: Json_decode.field("data_type_property", MsisdnType$ReactHooksTemplate.decode, json)
          };
  } else if (dataTypeName === DateType$ReactHooksTemplate.dataTypeName) {
    return {
            TAG: "DateType",
            _0: Json_decode.field("data_type_property", DateType$ReactHooksTemplate.decode, json)
          };
  } else {
    return {
            TAG: "TextType",
            _0: Json_decode.field("data_type_property", TextType$ReactHooksTemplate.decode, json)
          };
  }
}

function encode(t) {
  switch (t.TAG) {
    case "ListType" :
        return ListType$ReactHooksTemplate.encode(t._0);
    case "NumberType" :
        return NumberType$ReactHooksTemplate.encode(t._0);
    case "EmailType" :
        return EmailType$ReactHooksTemplate.encode(t._0);
    case "DateType" :
        return DateType$ReactHooksTemplate.encode(t._0);
    case "MsisdnType" :
        return MsisdnType$ReactHooksTemplate.encode(t._0);
    case "TextType" :
        return TextType$ReactHooksTemplate.encode(t._0);
    
  }
}

exports.decode = decode;
exports.dataTypeName = dataTypeName;
exports.dataTypeNames = dataTypeNames;
exports.dataTypeFromName = dataTypeFromName;
exports.defaultDataType = defaultDataType;
exports.valueAsString = valueAsString;
exports.encode = encode;
/* defaultDataType Not a pure module */
